<template>
  <div class="full-logo">
    <!-- <img class="logoimg" src="./DataExpo.png" alt=""> -->
    <img src="./dde-new-logo.png" alt="" srcset="" width="120px" @click="goTo('https://deep-time.org/#/')" />
    <img
      src="./acemap.svg"
      alt=""
      srcset=""
      width="120px"
      style="margin-left: 16px"
      @click="goTo('https://acemap.info/')"
    />
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      hiddenHeaderRoute: ["home"],
    };
  },
  methods: {
    goTo(url) {
      window.open(url, '_blank')
    }
  }
};
</script>
<style lang="less" scoped>
* {
  font-family: ddefont;
}
.full-logo {
  display: flex;
  align-items: center;
  img {
    cursor: pointer;
  }
}
.logo {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
}
.logoimg {
  width: 90px;
  float: left;
  margin-left: 20px;
  margin-top: 5px;
}
.datastore {
  font-size: 30px;
  font-weight: bold;
  display: inline-block;
  margin-top: 10px;
  margin-left: 10px;
}
</style>